import React from 'react';
import Slider from 'react-slick';
import { theme } from '../../../styles'

export default class extends React.Component {

  constructor() {
    super();
    this.state = {
      viewportSize: 1024
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.viewportSize();
      if (window.addEventListener) {
        window.addEventListener("resize", this.viewportSize, false);
      } else if (window.attachEvent) {
        window.attachEvent("onresize", this.viewportSize);
      }
    }
  }

  viewportSize = () => {
    this.setState({ viewportSize: window.innerWidth })
  }

  render() {
    const { children, products } = this.props;
    const breakPoint = parseInt(theme.breakpoints.l.replace('px', ''));
    const settings = {
      infinite: true,
      speed: 500,
      slidesToShow: this.state.viewportSize <= breakPoint ? 1 : (products ? 5 : 3),
      slidesToScroll: this.state.viewportSize <= breakPoint ? 1 : (products ? 5 : 3),
      dots: true
    };
    return (
      <Slider {...settings}>
        {children}
      </Slider>
    )
  }
}
